import config from "../_config/config";
import { authHeader, postHeader } from "../_helpers";
import axios from "axios";

axios.defaults.baseURL = config.apiUrl;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.put["Content-Type"] = "application/json";
axios.defaults.headers.put["X-Requested-With"] = "XMLHttpRequest";

export const cittadinoService = {
  getFamilyMembers,
  storeFamilyMembers,
  updateFamilyMembers,
  getCaregivers,
  inviteCaregiver,
  approveCaregiver,
  disapproveCaregiver,
  getMeasurements,
  postMeasurements,
  getExamHistory,
  downloadResource,
  storePathology,
  getPathologies,
  updatePathology,
  getUserById,
  getCode,
  validateUserCode,
  storeTherapy,
  updateTherapy,
  getTherapies,
  deleteTherapy,
  updateMeasurement,
  deleteMeasurement,
  therapyRecap,
  getUserBots,
  updateUserBots,
  deleteBotAccess,
  updateConsense,
  storeSuspendedFilledSurvey,
  storeFirebaseToken,
  attachUploadedResourceToUser,
  deleteUserPropic,
  storeEmergencyContact,
  getUserEmergencyContacts,
  deleteEmergencyContact,
  updateEmergencyContact,
  suspendUserProfile,
  getUserCaregivers,
  patientStoreFilledSurvey,
  getUserFilledSurveys,
  getOwnSubscriptions,
  storeOwnSubscription,
  sendSubscriptionCardEmail,
  deleteOwnSubscription,
  changeSubscriptionRenewalStatus,
  changeSubscriptionDataFine,
  getUserStoricoPagamenti,
  updateUser,
  docInvite,
  storeCalendarEvent,
  updateCalendarEvent,
  deleteCalendarEvent,
  getCittadinoPopupQuestions,
  postCittadinoPopupAnswer,
  verifyVoucher,
  subscribeFreeVoucherSubscription,
  getOwnTherapeuticPlans,
  downloadMeasurementResource,
  getUserAnamnesi,
  storeAnamnesi,
  storeAnamnesiItem,
  updateAnamnesiItem,
  deleteAnamnesiItem,
  inviaSegnalazione,
  getOwnSegnalazioni,
  getSegnalazioneThread,
  rispondiSegnalazione,
  getUnreadSegnalazioniCount,
  getEwsHistory,
};

function storeFirebaseToken(data) {
  const sett = { headers: authHeader() };
  return axios
    .post("users/push/token/", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getFamilyMembers() {
  const sett = { headers: authHeader() };
  return axios
    .get("familymembers", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function storeFamilyMembers(data) {
  const sett = { headers: authHeader() };
  return axios
    .post("familymembers", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updateFamilyMembers(data) {
  const sett = { headers: authHeader() };
  var endpoint = "familymembers/" + data.hashid;
  return axios
    .put(endpoint, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getCaregivers(filters = null) {
  var sett = { headers: authHeader() };
  if (filters) {
    sett = { headers: authHeader(), params: filters };
  }
  return axios
    .get("familymembers/caregivers/own", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function inviteCaregiver(data) {
  const sett = { headers: authHeader() };
  return axios
    .post("familymembers/caregiver/invite", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function approveCaregiver(data) {
  const sett = { headers: authHeader() };
  return axios
    .post("familymembers/caregiver/approve", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function disapproveCaregiver(data) {
  const sett = { headers: authHeader() };
  return axios
    .post("familymembers/caregiver/disapprove", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getMeasurements(filters = null) {
  var sett = { headers: authHeader() };
  if (filters) {
    sett = { headers: authHeader(), params: filters };
  }
  return axios
    .get("exams/measurements/all", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function postMeasurements(data) {
  const sett = { headers: authHeader() };
  return axios
    .post("exams/measurements/add", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

/**
 * Invia una segnalazione del cittadino, associata a un progetto.
 * Riusa l'endpoint queries (POST /queries): il backend instrada i cittadini
 * su createFromApi, valida arruolamento + servizio segnalazioni e imposta project_id.
 * @param {Object} payload - { descrizione, project_id }
 */
function inviaSegnalazione({ descrizione, project_id }) {
  const sett = { headers: authHeader() };
  const data = {
    type: "paziente",
    subject: "Segnalazione paziente",
    description: descrizione,
    project_id,
  };
  return axios
    .post("queries", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

// Elenco delle proprie segnalazioni (solo thread principali).
function getOwnSegnalazioni(filters = {}) {
  const sett = { headers: authHeader(), params: filters };
  return axios
    .get("queries/own/list", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

// Conteggio delle risposte non lette (badge menu).
function getUnreadSegnalazioniCount() {
  const sett = { headers: authHeader() };
  return axios
    .get("queries/own/unread-count", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

// Thread completo (segnalazione + risposte) di una propria segnalazione.
function getSegnalazioneThread(queryHashid) {
  const sett = { headers: authHeader() };
  return axios
    .get(`queries/${queryHashid}/thread`, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

// Risposta del cittadino in un thread esistente.
function rispondiSegnalazione({ parent_query_id, descrizione }) {
  const sett = { headers: authHeader() };
  const data = {
    // Prefisso "Re:" così la vista operatore riconosce la risposta come parte del
    // thread e non la mostra come segnalazione separata.
    type: "paziente",
    subject: "Re: Segnalazione",
    description: descrizione,
    parent_query_id,
  };
  return axios
    .post("queries", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getExamHistory(hash, filters = null) {
  var sett = { headers: authHeader() };
  if (filters) {
    sett = { headers: authHeader(), params: filters };
  }
  var endpoint = "exams/measurements/history/" + hash;
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function downloadResource(hash) {
  // const sett = { headers:authHeader(), responseType:'blob', Accept:"application/pdf" };
  const sett = { headers: authHeader(), responseType: "blob" };
  var endpoint = "resources/private/" + hash;
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function storePathology(data) {
  const sett = { headers: authHeader() };
  return axios
    .post("pathologies", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updatePathology(data) {
  const sett = { headers: authHeader() };
  var endpoint = "pathologies/" + data.hashid;
  return axios
    .put(endpoint, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getPathologies(filters = null) {
  var sett = { headers: authHeader() };
  if (filters) {
    sett = { headers: authHeader(), params: filters };
  }
  return axios
    .get("pathologies", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getUserById(hashid) {
  const sett = { headers: authHeader() };
  var endpoint = "users/" + hashid;
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getCode() {
  const sett = { headers: authHeader() };
  return axios
    .get("users/own/code", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function validateUserCode(data) {
  const sett = { headers: authHeader() };
  return axios
    .post("users/own/code/validate", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function storeTherapy(data) {
  const sett = { headers: authHeader() };
  return axios
    .post("therapies", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updateTherapy(data) {
  const sett = { headers: authHeader() };
  var endpoint = "therapies/" + data.hashid;
  return axios
    .put(endpoint, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function deleteTherapy(data) {
  const sett = { headers: authHeader() };
  var endpoint = "therapies/" + data.hashid;
  return axios
    .delete(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getTherapies(filters = null) {
  var sett = { headers: authHeader() };
  if (filters) {
    sett = { headers: authHeader(), params: filters };
  }
  return axios
    .get("therapies", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updateMeasurement(data, hash) {
  const sett = { headers: authHeader() };
  var endpoint = "exams/measurements/edit/" + hash;
  return axios
    .put(endpoint, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function deleteMeasurement(hash) {
  const sett = { headers: authHeader() };
  var endpoint = "exams/measurements/delete/" + hash;
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function therapyRecap(hash) {
  const sett = { headers: authHeader(), responseType: "blob" };
  var endpoint = "therapies/download/" + hash;
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getUserBots() {
  const sett = { headers: authHeader() };
  return axios
    .get("users/bots/access", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updateUserBots(data, hash) {
  const sett = { headers: authHeader() };
  var endpoint = "users/bots/status/" + hash;
  return axios
    .post(endpoint, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function deleteBotAccess(hash) {
  const sett = { headers: authHeader() };
  var endpoint = "users/bots/delete/" + hash;
  return axios
    .delete(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updateConsense(data) {
  const sett = { headers: authHeader() };
  return axios
    .post("users/change/consenses", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function storeSuspendedFilledSurvey(data) {
  const sett = { headers: authHeader() };
  return axios
    .post("activities/survey/suspended/filled", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function attachUploadedResourceToUser(hashid) {
  const sett = { headers: authHeader() };

  return axios
    .post("users/profile/picture", { resource: hashid }, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function deleteUserPropic() {
  const sett = { headers: authHeader() };
  var endpoint = "users/profile/picture/delete";
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function storeEmergencyContact(data) {
  const sett = { headers: authHeader() };
  return axios
    .post("users/emergencycontacts/", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getUserEmergencyContacts(hash = null) {
  const sett = { headers: authHeader() };
  const hashid = hash ? hash : "";
  var endpoint = "users/emergencycontacts/" + hashid;
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updateEmergencyContact(data) {
  const sett = { headers: authHeader() };
  var endpoint = "users/emergencycontacts/" + data.hashid;
  return axios
    .put(endpoint, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function deleteEmergencyContact(hashid) {
  const sett = { headers: authHeader() };
  var endpoint = "users/emergencycontacts/" + hashid;
  return axios
    .delete(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function suspendUserProfile(hashid, formData) {
  const sett = { headers: authHeader() };
  var endpoint = "users/change/suspension/" + hashid;
  return axios
    .patch(endpoint, formData, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getUserCaregivers(user, filters = null) {
  const sett = { headers: authHeader(), params: filters };
  const endpoint = "familymembers/caregivers/user/" + user;
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function patientStoreFilledSurvey(data) {
  const sett = { headers: authHeader() };
  return axios
    .post("activities/surveys/filled/patient", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getUserFilledSurveys(hashid, filters = null) {
  const sett = { headers: authHeader(), params: filters };
  const endpoint = "activities/surveys/filled/user/" + hashid;
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getOwnSubscriptions(filters = null, hashid = null) {
  const sett = { headers: authHeader(), params: filters };
  const endpoint = "users/own/subscriptions/" + (hashid ?? "");
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function storeOwnSubscription(id, data = {}) {
  const sett = { headers: authHeader() };
  const endpoint = "users/own/subscriptions/" + id;
  return axios
    .post(endpoint, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function sendSubscriptionCardEmail(hashid, cardImageBase64) {
  const sett = { headers: authHeader() };
  const endpoint = "users/own/subscriptions/" + hashid + "/send-card-email";
  return axios
    .post(endpoint, { card_image: cardImageBase64 }, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function deleteOwnSubscription(id) {
  const sett = { headers: authHeader() };
  const endpoint = "users/subscriptions/" + id;
  return axios
    .delete(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function changeSubscriptionRenewalStatus(id, status) {
  const sett = { headers: authHeader() };
  const endpoint = "users/subscriptions/status/" + id;
  return axios
    .patch(endpoint, { rinnovo_abilitato: status }, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function changeSubscriptionDataFine(id, data) {
  const sett = { headers: authHeader() };
  const endpoint = "users/subscriptions/status/" + id;
  return axios
    .patch(endpoint, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getUserStoricoPagamenti() {
  const sett = { headers: authHeader() };
  return axios
    .get("purchases/user/payments", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updateUser(form) {
  const sett = { headers: authHeader() };
  var endpoint = "users/" + form.hashid;
  return axios
    .put(endpoint, form.data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function docInvite(docInfo) {
  const sett = { headers: authHeader() };
  return axios
    .post("users/contatti/privati/medico/invito", docInfo, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function storeCalendarEvent(event, userHash) {
  const sett = { headers: authHeader() };
  return axios
    .post("users/" + userHash + "/agendaevents", event, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updateCalendarEvent(event, userHash, eventHash) {
  const sett = { headers: authHeader() };
  return axios
    .put("users/" + userHash + "/agendaevents/" + eventHash, event, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function deleteCalendarEvent(userHash, eventHash) {
  const sett = { headers: authHeader() };
  return axios
    .delete("users/" + userHash + "/agendaevents/" + eventHash, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getCittadinoPopupQuestions() {
  const sett = { headers: authHeader() };
  return axios
    .get("users/popup/questions/unanswered", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function postCittadinoPopupAnswer(data) {
  const sett = { headers: authHeader() };
  return axios
    .post("users/popup/questions", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function verifyVoucher(code) {
  const sett = { headers: authHeader() };
  const endpoint = "subscriptions/vaucher/" + code;
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function subscribeFreeVoucherSubscription(hash) {
  const sett = { headers: authHeader() };
  const endpoint = "subscriptions/subscribe/free/" + hash;
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getOwnTherapeuticPlans(filters) {
  const sett = { headers: authHeader(), params: filters }
  return axios
    .get("users/own/therapeuticplans", sett)
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((err) => {
      var error = err.response
      return Promise.reject(error)
    })
}

function downloadMeasurementResource(hash) {
  const sett = { headers: authHeader(), responseType: "blob" }
  var endpoint = "exams/measurements/" + hash + "/allegato"
  return axios
    .get(endpoint, sett)
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((err) => {
      var error = err.response
      return Promise.reject(error)
    })
}

function getUserAnamnesi(hashid, subjectType = 'user_in_app') {
  const sett = { 
    headers: authHeader(),
    params: { subject_type: subjectType }
  };
  const endpoint = `anamnesi/users/all/${hashid}`;
  return axios
    .get(endpoint, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function storeAnamnesi(data, subjectType = 'user_in_app') {
  const sett = { headers: authHeader() };
  const payload = {
    ...data,
    subject_type: subjectType
  };
  return axios
    .post("anamnesi", payload, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function storeAnamnesiItem(data, subjectType = 'user_in_app') {
  const sett = { headers: authHeader() };
  const payload = {
    ...data,
    subject_type: subjectType
  };
  return axios
    .post("anamnesi/items", payload, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function updateAnamnesiItem(hashid, data) {
  const sett = { headers: authHeader() };
  return axios
    .put(`anamnesi/items/${hashid}`, data, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function deleteAnamnesiItem(hashid) {
  const sett = { headers: authHeader() };
  return axios
    .delete(`anamnesi/items/${hashid}`, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function getEwsHistory(patientId, filters = null) {
  var sett = { headers: authHeader() };
  if (filters) {
    sett = { headers: authHeader(), params: filters };
  }
  return axios
    .get("ews/history/" + patientId, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}
